var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-autocomplete',{ref:"autocomplete",attrs:{"data":_vm.filteredData,"loading":_vm.isFetching,"field":_vm.field},on:{"select":_vm.selectOption},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})}
var staticRenderFns = []

export { render, staticRenderFns }